import React from 'react';

const Solutions = () => {
  return (
    <div className="relative bg-white">
      {/* Background Layer */}

      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className=" mt-2  md:mt-2  md:mb-5 mb-2" >
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold text-black">
          Contracts
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:-mt-5   md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744223318/image-1_evxawu.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
            <div className="absolute inset-0 flex justify-center items-center">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
              />
            </div>
          </div>
          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10 text-white">
            <p className="text-[12px] md:text-[43px] font-bold text-white">Contracts </p>
          
          </div>
             {/* Logo */}
             <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
              {/* See More Button */}
        <div className="absolute bottom-0 right-0 bg-[#152C24] z-20 rounded-tl-[50px] flex items-center justify-evenly md:px-4 px-1 w-[100px] h-[20px] md:w-[320px] md:h-[82px]">
          <a href="/experiencemain">
            <div className="flex items-center justify-between space-x-3 md:space-x-16 mt-1 md:mt-1 ml-2 md:ml-7">
              <p className="text-[8px] md:text-[23.5px] text-white font-bold">Read more</p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[15px] md:w-[60px] h-[15px] md:h-[50px] object-contain"
              />
            </div>
          </a>
        </div>
        
        </div>
        <p className='md:text-[32px] text-[8px] font-normal md:mt-16 mt-2'>
  <div className="md:mb-10 mb-3" style={{ lineHeight: '1.30' }}>
    The Farmnet Mobile App offers a Farming Communities Solution designed to enhance collaboration, knowledge exchange, and support among farmers. This feature fosters a connected network where agricultural stakeholders can share experiences, access resources, and collectively address challenges.
  </div>
  <div className='h-5'></div>
  <strong>How Farmer Communities Utilize the Farming Communities Solution</strong> 
  <div className='md:h-16 h-5'></div>

  <div>
  <div  style={{ lineHeight: '1.30' }}>
    <strong>Knowledge Sharing and Collaboration:</strong> Farmers can participate in forums and discussion groups within the app to exchange farming techniques, discuss challenges, and share solutions, thereby enhancing collective knowledge and problem-solving capabilities.
  </div>
  <div style={{ lineHeight: '1.30' }}>
    <strong>Access to Resources:</strong> The app provides information on sustainable farming practices, market trends, and opportunities for group investments, enabling farmers to make informed decisions and improve their livelihoods.
  </div>
  </div>
  <div className="md:mb-10 mb-3 mt-5" style={{ lineHeight: '1.30' }}>
  <div className='h-5'></div>

 <strong> Benefits of Using the Farming Communities Solution</strong>
 <div className='h-5'></div>

    </div>
    <div className="md:text-[47px] text-[12px] font-normal md:mt-16 mt-2 space-y-6 md:space-y-10">
  {[
    {
      number: "1.",
      title: "Enhanced Learning and Skill Development:",
      text: "Engaging with a community of farmers allows individuals to learn new techniques, adopt best practices, and stay updated on agricultural innovations, leading to improved farming efficiency and productivity.",
    },
    {
      number: "2.",
      title: "Economic Empowerment:",
      text: "Collaborative efforts, such as group purchasing of inputs or collective marketing of produce, can reduce costs and increase bargaining power, thereby boosting farmers' incomes.",
    },
    {
      number: "3.",
      title: "Social Connectivity and Support:",
      text: "The app fosters a supportive network where farmers can share experiences, seek advice, and collaborate on projects, enhancing social bonds and community cohesion.",
    },
    {
      number: "4.",
      title: "Access to Market Opportunities:",
      text: "Through the community network, farmers can connect with buyers, learn about market demands, and negotiate better terms, improving market access and sales opportunities.",
    },
    {
      number: "5.",
      title: "The Farming Communities Solution",
      text: "within the Farmnet Mobile App serves as a vital platform for farmers to connect, learn, and collaborate, leading to sustainable agricultural practices, economic growth, and strengthened community bonds.",
    },
  ].map((item, idx) => (
    <div key={idx} className="flex items-start">
      <span className="font-bold mr-2">{item.number}</span>
      <p className="">
        <strong>{item.title}</strong> {item.text}
        
        <p className='md:mt-20 mt-8'>
      The Farming Communities Solution within the Farmnet Mobile App serves as a vital platform for farmers to  <strong>connect, learn, and collaborate, </strong> leading to sustainable agricultural practices, economic growth, and strengthened community bonds
      </p>
      </p>

    </div>
  ))}
</div>


</p>


    <div className='md:h-10 h-3'></div>
      </div>
    </div>
  );
};

export default Solutions;
